export default "__VITE_ASSET__y6yEuihe__"